<template>
  <div class="min-h-screen flex items-center flex-col justify-center antialiased text-yank">
    <h1 class="text-xl font-bold">Media Modal Demo</h1>
    <div>
      ---
    </div>

    <div class="mt-4">
      You're authenticated as {{ user.name }}
    </div>

    <div class="mt-4">
      <label for="product_id" class="text-yank text-sm">
        Pick Product
      </label>
      <div>
        <div class="relative">
          <select id="product_id" name="product_id" class="border block w-full pl-3 pr-7 h-9 text-xs border-payne focus:outline-none focus:border-payneFire rounded-lg appearance-none text-payneFire" v-model="productId">
            <option :value="null">- Select Product -</option>
            <option v-for="product in products" :value="product">
              {{ product }}
            </option>
          </select>
          <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
            <svg class="h-4 w-4 text-payneFire" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </span>
        </div>
      </div>
    </div>

    <div class="mt-4 relative">
      <vue-tithely-media
        :sso-token="''"
        :product-id="productId"
        :location-id="locationId"
        :access-token="token"
        :endpoint="endpoint"
        @selected="handleSelected"
      >
        <template v-slot="{ toggle, disabled }">
          <button @click.prevent="toggle" type="button" class="bg-aquamarine text-sm font-semibold text-white py-2 px-4 rounded-lg shadow-md hover:opacity-90 focus:outline-none focus:ring-aquamarine focus:ring focus:ring-offset-2 disabled:bg-cosmos disabled:opacity-60" :disabled="! productId || ! disabled">
            Open Media Modal
          </button>
        </template>
      </vue-tithely-media>
    </div>

    <div class="mt-4" v-if="selected > 0">
      You selected {{ selected }} {{ selected == 1 ? 'file' : 'files'}}
    </div>
  </div>
</template>

<script>
  import VueTithelyMedia from 'vue-tithely-media'
  export default {
    props: ['user', 'locationId', 'products', 'endpoint', 'token'],

    data() {
      return {
        productId: null,
        types: [
          // 'image',
          'video',
          // 'audio',
          // 'pdf',
          // 'social-media',
          // 'graphic'
        ],
        selected: 0,
      }
    },

    components: {
      VueTithelyMedia,
    },

    methods: {
      handleSelected(urls) {
        this.selected = urls.length
        console.log('handling selected', urls)
      }
    }
  }
</script>
